import { apiKeys } from "../../app/services/apiKeys";
import { ReCaptcha as SharedReCaptcha } from "../shared/ReCaptcha";

export const SignUpReCaptcha = () => (
  <SharedReCaptcha apiKey={apiKeys.value.reCaptcha} />
);
